import { useEffect, useState } from 'react'

/** The on-screen keyboard shrinks the visual viewport by well over this. */
const KEYBOARD_MIN_PX = 150

function keyboardIsOpen(): boolean {
  const viewport = window.visualViewport
  if (!viewport) return false
  return window.innerHeight - viewport.height > KEYBOARD_MIN_PX
}

/** True while the on-screen keyboard covers part of the screen (touch devices). */
export function useKeyboardOpen(): boolean {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const viewport = window.visualViewport
    if (!viewport) return
    const update = () => setOpen(keyboardIsOpen())
    update()
    viewport.addEventListener('resize', update)
    viewport.addEventListener('scroll', update)
    return () => {
      viewport.removeEventListener('resize', update)
      viewport.removeEventListener('scroll', update)
    }
  }, [])

  return open
}
